var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9399 0.181641H0.679907C0.429907 0.181641 0.199931 0.321634 0.0799314 0.541634C-0.0400686 0.771634 -0.0201419 1.04164 0.129858 1.25164L5.35984 8.61163C5.35984 8.61163 5.35985 8.61164 5.36985 8.62164C5.55985 8.88164 5.65989 9.19164 5.65989 9.51163V15.5116C5.65989 15.6916 5.72983 15.8616 5.84983 15.9816C5.97983 16.1116 6.14992 16.1816 6.31992 16.1816C6.40992 16.1816 6.49993 16.1616 6.57993 16.1316L9.51987 15.0116C9.77987 14.9316 9.95994 14.6816 9.95994 14.3816V9.51163C9.95994 9.19164 10.0599 8.88164 10.2499 8.62164C10.2499 8.62164 10.2499 8.62163 10.2599 8.61163L15.4898 1.25164C15.6398 1.04164 15.6599 0.771634 15.5399 0.541634C15.4199 0.321634 15.1899 0.181641 14.9399 0.181641ZM9.59983 8.14164C9.30983 8.54164 9.14988 9.01163 9.14988 9.51163V14.2816L6.46995 15.3016V9.50164C6.46995 9.01164 6.30987 8.53164 6.01987 8.13164L0.949926 0.981636H14.6799L9.59983 8.14164Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.32761b541b3a5d928cae6638974cb95e.svg";
export { ForwardRef as ReactComponent };